import { rem } from "@myphx-engineering/phx-design-system/framework";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/Illustration.tsx
const ILLUSTRATION_SIZE = {
	icon: rem("24px"),
	xs: rem("80px"),
	sm: rem("100px"),
	md: rem("120px"),
	lg: rem("140px"),
	xl: rem("200px")
};
const Illustration = ({ alt, svgFile, size = "lg" }) => {
	const svgSize = ILLUSTRATION_SIZE[size];
	return /* @__PURE__ */ jsx("img", {
		src: `/static/libraries/myphx-lib/illustrations/${svgFile}`,
		"aria-label": alt,
		style: {
			height: svgSize,
			width: svgSize,
			padding: "var(--mantine-spacing-xxs)"
		},
		"data-testid": "illustration"
	});
};

//#endregion
export { ILLUSTRATION_SIZE, Illustration };